module.exports = __webpack_public_path__ + "img/sun.9afa5504.png";